import {
  Box,
  Grid,
  IconButton,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogActions,
  Button,
} from "@mui/material";
import Input from "../../../../../../components/Input";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useClaimFormStore } from "../../../../../../store/useClaimFormStore";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import FileUpload from "../../../../../../components/FileUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getDocument } from "../../../../../../services/dashboard";

export default function PolicyInfoForm({
  policyInfoData,
  onPolicyCommentChange,
  commentData,
  documentData: initialDocumentData,
  isAssigned,
  claimStatus,
  policyComment,
  isEditable,
  handlePolicyFieldChange,
  iceClaimNumber,
}: any) {
  const [documents, setDocuments] = useState<any[]>([]);
  const [openPreview, setOpenPreview] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState<any>(null);
  const [fileErrors, setFileErrors] = useState("");

  const addDocument = useClaimFormStore((state) => state.addDocument);
  const uploadedFile = useClaimFormStore(
    (state) => state.documents["policy_document"]
  );
  const clearDocuments = useClaimFormStore((s) => s.clearDocuments);

  const handleClosePreview = () => {
    setOpenPreview(false);
    setSelectedDoc(null);
  };

  useEffect(() => {
    if (uploadedFile) {
      setDocuments([
        {
          file_name: uploadedFile.name,
          file_url: URL.createObjectURL(uploadedFile),
          isLocal: true,
        },
      ]);
    } else {
      setDocuments(initialDocumentData);
    }
  }, [uploadedFile]);

  const handleDeleteDocument = (index: number) => {
    const updatedDocs = [...documents];
    updatedDocs.splice(index, 1);
    setDocuments(updatedDocs);
  };

  const comments = commentData?.filter(
    (comment: any) => comment.section_type === "POLICY_INFORMATION"
  );

  const formatDate = (dateString: string) => {
    const d = new Date(dateString);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  const handlePreview = async (doc: any) => {
    try {
      if (doc.isLocal) {
        setSelectedDoc(doc);
        setOpenPreview(true);
      } else {
        const res = await getDocument(iceClaimNumber, doc?.document_id);
        if (!res || res.status !== 200) {
          throw new Error("Failed to fetch document");
        }

        const blob = res.data;
        const url = URL.createObjectURL(blob);
        setSelectedDoc({ ...doc, file_url: url });
        setOpenPreview(true);
      }
    } catch (err) {
      console.error("Error fetching file:", err);
    }
  };

  const handleDownload = async (doc: any) => {
    try {
      const res = await getDocument(iceClaimNumber, doc.document_id);
      if (!res || res.status !== 200) {
        throw new Error("Failed to download document");
      }

      const blob = res.data;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = doc.file_name || "document.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading file:", err);
    }
  };

  useEffect(() => {
  if (!isEditable) {
    clearDocuments();
  }
}, [isEditable]);


  return (
    <Grid
      container
      rowSpacing={5}
      columnSpacing={10}
      mt={1}
      textAlign="left"
      p={3}
    >
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyInfoData?.policy_number}
          height={40}
          width="100%"
          label="Policy Number"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyInfoData?.policy_type}
          height={40}
          width="100%"
          label="Policy Type"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyInfoData?.policy_status}
          height={40}
          width="100%"
          label="Policy Status"
          backgroundColor="background.paper"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={iceClaimNumber}
          height={40}
          width="100%"
          label="Claim Number"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyInfoData?.product_history}
          height={40}
          width="100%"
          label="Product History"
          backgroundColor="background.paper"
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyInfoData?.member_name}
          height={40}
          width="100%"
          label="Main Member Name"
          backgroundColor="background.paper"
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Input
          disabled={!isEditable}
          value={policyInfoData?.member_contact_number}
          height={40}
          width="100%"
          label="Main Member Contact Details"
          backgroundColor={
            isEditable ? "background.default" : "background.paper"
          }
          onChange={(e: any) => {
            const val = e.target.value;
            handlePolicyFieldChange("member_contact_number", val);
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}></Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Grid />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <Box height={48}>
          <Typography fontWeight={600} textAlign="left" fontSize={18}>
            RMA Policy Report
          </Typography>
          {documents.map((doc: any, index: number) => (
            <Box
              key={index}
              sx={{
                background: "#F5EEE9",
                color: "#FF0000",
                borderRadius: 1,
                px: 1.5,
                py: 0.5,
                display: "flex",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Box display="flex" alignItems="center" gap={1} flexGrow={1}>
                <PictureAsPdfIcon />
                <Box>
                  <Typography fontSize={14}>{doc.file_name}</Typography>
                  <Typography fontSize={12} color="text.secondary"></Typography>
                </Box>
              </Box>
              {isEditable ? (
                <IconButton
                  onClick={() => handleDeleteDocument(index)}
                  size="small"
                >
                  <DeleteIcon sx={{ color: "#FF0000" }} />
                </IconButton>
              ) : (
                <IconButton onClick={() => handlePreview(doc)} size="small">
                  <VisibilityIcon sx={{ color: "#EC6E00" }} />
                </IconButton>
              )}
            </Box>
          ))}
          {isEditable && documents.length === 0 && (
            <Box mt={2}>
              <FileUpload
                inputId="rma-policy"
                onChange={(e: any) => {
                  if (e.target.files.length > 0) {
                    const file = e.target.files[0];
                    if (file.size > 2 * 1024 * 1024) {
                    setFileErrors( "File must be less than 2MB")
                    return;
                  }
                    const newDoc = {
                      file_name: file.name,
                      file_url: URL.createObjectURL(file),
                      isLocal: true,
                    };
                    setDocuments([newDoc]);
                    addDocument("policy_document", file);
                  }
                }}
              />
               {fileErrors && (
              <Typography color="error" fontSize={14}>
                {fileErrors}
              </Typography>
            )}
            </Box>
          )}
        </Box>
      </Grid>
      {comments?.length > 0 && (
        <Grid size={12} mt={3}>
          {comments.map((comment: any, index: number) => (
            <Accordion
              key={index}
              sx={{
                backgroundColor: "#F7F7F7",
                boxShadow: "none",
                borderRadius: "6px",
                mb: 2,
                border: "1px solid #E0E0E0",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight={600} fontSize={14}>
                    {comment.commentedByName}{" "}
                    <Typography
                      component="span"
                      fontWeight={600}
                      color="#EC6E00"
                    >
                      - {comment.role_at_time_of_comment?.replace(/_/g, " ").toUpperCase()}
                    </Typography>
                  </Typography>
                  <Typography fontSize={12} color="text.secondary">
                    {new Date(comment.created_on).toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                    })}{" "}
                    | {formatDate(comment.created_on)}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Typography fontSize={15} color="#333" lineHeight={1.6}>
                  {comment.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      )}
      {isAssigned && claimStatus !== "PAID" && (
        <Grid size={{ md: 12 }} mt={3}>
          <Typography
            variant="body1"
            fontWeight={600}
            fontSize={18}
            sx={{ display: "block", textAlign: "left" }}
          >
            Comment
          </Typography>
          <TextField
            multiline
            rows={4}
            variant="outlined"
            fullWidth
            disabled={isEditable}
            value={policyComment}
            onChange={onPolicyCommentChange}
          />
        </Grid>
      )}
      <Dialog
        open={openPreview}
        onClose={handleClosePreview}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Document Preview</DialogTitle>
        <DialogContent dividers>
          {selectedDoc ? (
            <object
              data={selectedDoc.file_url}
              type="application/pdf"
              width="100%"
              height="600px"
            >
              <p>
                PDF preview is not supported in this browser.{" "}
                <a
                  href={selectedDoc.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download PDF
                </a>
              </p>
            </object>
          ) : (
            <Typography>Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDownload(selectedDoc)}
            color="primary"
            variant="outlined"
          >
            Download
          </Button>

          <Button
            onClick={handleClosePreview}
            color="secondary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
